export class Rock {
    id!: string
    userId!: string
    name!: string
    details!: string
    dueDate!: Date
    doneDate!: Date
    status!: number // 0: Off Track, 1: On Track, 2: Done, 3: Cancelled
    type!: number // 0: Individual, 1: Organization
    isArchived!: boolean
    includeInOneYearGoals = false
    createdOn!: Date
    lastmodifiedOn!: Date
    createdByid!: string
    lastmodifiedByid!: string

    meetingIds: string[] = []
    milestoneIds: string[] = []

    userIds: string[] = [] // Multiple user can only be assigned when adding a new ToDo, and multiple ToDos will be created for each user

    userName!: string
    userNames!: string[]

    meetingName!: string
}
